import { IonIcon } from "@ionic/react";
import { brushSharp, closeSharp, pencilSharp } from "ionicons/icons";
import { ActionBox } from "./EncarteProduct.styles";

export default function ProductActionBox({
  onEdit,
  onStyle,
  onClose,
  className = "action-box",
}) {
  return (
    <ActionBox className={className}>
      <span onClick={onEdit}>
        Editar <IonIcon icon={pencilSharp} />
      </span>
      <span onClick={onStyle}>
        Alterar estilo <IonIcon icon={brushSharp} />
      </span>
      <span onClick={onClose}>
        Fechar <IonIcon icon={closeSharp} />
      </span>
    </ActionBox>
  );
}
